import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import Partner from "../../../../types/Partner";
// import partners from "../../../../data/MOCK_DATA";

export const fetchAllPartners = createAsyncThunk(
  "FETCH_ALL_PARTNERS",
  async () => {
    try {
      const response = await Axios.get(process.env.PARTNERS_URL);
      const partners: Partner[] = response.data;
      return { partners };
    } catch (e) {
      console.log(e);
      throw new Error("Nie udało się pobrać danych. Spróbuj ponownie.");
    }
  }
);
